// Internationalization configuration with Vue-i18n
import { createI18n } from 'vue-i18n'

import { useUserStore } from '@/stores/user'

import en from './locales/en.json'
import es from './locales/es.json'

// const messages = {
//   en: {
//     nav: {
//       home: 'Marga application',
//       about: 'About'
//     },
//     home: {
//       header: 'Welcome to the Marga application'
//     },
//     about: {
//       header: 'About Marga'
//     }
//   },
//   es: {
//     nav: {
//       home: 'Aplicación Marga',
//       about: 'Acerca de Marga'
//     },
//     home: {
//       header: 'Bienvenido/a a Marga'
//     },
//     about: {
//       header: 'Acerca de Marga'
//     }
//   }
// }

export default createI18n({
  locale: import.meta.env.VITE_DEFAULT_LOCALE,
  fallbackLocale: import.meta.env.VITE_FALLBACK_LOCALE,
  // locale: "en",
  // fallbackLocale: "en",
  legacy: false,
  messages: {
    en,
    es
  },
  // suppress warnings for missing translations during development,
  // to not clutter the console and see other important warnings.
  // (during production they are suppresed anyway)
  // missingWarn: false,
  // fallbackWarn: false
})
